export enum SrchDataBioVisibility {
    "WHITELISTED" = "WHITELISTED", 
    PUBLIC_COMPANY_EXECUTIVE = "PUBLIC_COMPANY_EXECUTIVE", 
    TERMINAL_USER_AND_EXECUTIVE = "TERMINAL_USER_AND_EXECUTIVE"
}
